import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { MenuService } from 'src/app/services/menu';
import { Subscription } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
	selector: 'app-titles',
	templateUrl: './titles.component.html',
	styleUrls: ['./titles.component.scss'],
})
export class TitlesComponent implements OnInit, OnDestroy {
	
	@HostBinding('class.print-hide')
	public readonly printHide = true;
	
	private subscription = new Subscription();
	public title: string;

	constructor(
		private menuService: MenuService,
		private router: Router,
	) {}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	ngOnInit(): void {
		this.subscription.add(this.router.events
			.pipe(filter(event => event instanceof NavigationStart))
			.subscribe(() => {
				this.title = '';
			}));
		this.subscription.add(this.menuService.title$.subscribe(title => {
			this.title = title;
		}));
	}
}
